// Source: https://stackoverflow.com/a/60702475

const DEFAULT_CMP = (a, b) => a - b;

function binaryHelper(arr, element, lBound, uBound, cmp = DEFAULT_CMP) {
  if (arr.length === 0) {
    arr.push(element);
    return;
  }
  if (uBound - lBound <= 1) {
    // binary search ends, we need to insert the element around here
    if (cmp(element, arr[lBound]) < 0) arr.splice(lBound, 0, element);
    else if (cmp(element, arr[uBound]) > 0) arr.splice(uBound + 1, 0, element);
    else arr.splice(uBound, 0, element);
    return;
  }
  // we look for the middle point
  const midPoint = Math.floor((uBound - lBound) / 2) + lBound;
  // depending on the value in the middle, we repeat the operation only on one slice of the array, halving it each time
  cmp(element, arr[midPoint]) < 0
    ? binaryHelper(arr, element, lBound, midPoint, cmp)
    : binaryHelper(arr, element, midPoint, uBound, cmp);
}

export default function binaryInsert(arr, element, cmp = DEFAULT_CMP) {
  binaryHelper(arr, element, 0, arr.length - 1, cmp);
}
